import { useState, useEffect, useCallback } from 'react';

// localStorage me is key ke andar favorite doctors ki list save hoti hai
const STORAGE_KEY = 'favoriteDoctors';
// same tab ke doosre components ko batane ke liye custom event
const EVENT = 'favorites-updated';

// har doctor ka unique id nikalne ke liye (jo field mile use le lega)
const getId = (item) =>
    item?.id ?? item?.userId ?? item?.applicationUserId ?? item?.email ?? item?.userName;

const read = () => {
    try {
        const raw = localStorage.getItem(STORAGE_KEY);
        return raw ? JSON.parse(raw) : [];
    } catch {
        return [];
    }
};

const write = (list) => {
    try {
        localStorage.setItem(STORAGE_KEY, JSON.stringify(list));
    } catch {
        // storage full / private mode - chup-chaap ignore
    }
    // isi tab ke baaki components ko update batao
    window.dispatchEvent(new Event(EVENT));
};

export default function useFavorites() {
    const [favorites, setFavorites] = useState(read);

    // storage change hone par (isi tab me ya doosre tab me) state sync karo
    useEffect(() => {
        const sync = () => setFavorites(read());
        window.addEventListener(EVENT, sync);       // same tab
        window.addEventListener('storage', sync);   // doosre tab
        return () => {
            window.removeEventListener(EVENT, sync);
            window.removeEventListener('storage', sync);
        };
    }, []);

    const isFavorite = useCallback(
        (item) => {
            const id = getId(item);
            return favorites.some((f) => getId(f) === id);
        },
        [favorites]
    );

    const addFavorite = useCallback((item) => {
        const list = read();
        const id = getId(item);
        if (!list.some((f) => getId(f) === id)) write([item, ...list]);
    }, []);

    const removeFavorite = useCallback((item) => {
        const id = getId(item);
        write(read().filter((f) => getId(f) !== id));
    }, []);

    const toggleFavorite = useCallback((item) => {
        const id = getId(item);
        const list = read();
        if (list.some((f) => getId(f) === id)) {
            write(list.filter((f) => getId(f) !== id));
        } else {
            write([...list, item]);
        }
    }, []);

    const clearFavorites = useCallback(() => write([]), []);

    return {
        favorites,
        count: favorites.length,
        isFavorite,
        addFavorite,
        removeFavorite,
        toggleFavorite,
        clearFavorites,
    };
}